//
//
//
//
//
//
//

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
  },
  data() {
    return {

    }
  }
}



// WEBPACK FOOTER //
// ./src/components/el-full-loading.vue